var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { MdArrowDropDown, MdClose } from 'react-icons/md';
import { components } from 'react-select';
import { useTheme } from 'styled-components';
import { Box, Spinner, Tag } from "./..";
import { Text } from "../Text";
import { InputWrapper as ControlWrapper } from "../TextInput/InputWrapper";
import styled from "../../styled";
import { noop } from "../../utils";
import { OptionContainer } from './OptionContainer';
var StyledPlaceholder = styled(Text)(function (_a) {
    var theme = _a.theme;
    return "\n  position: absolute;\n  left: " + theme.space.sm + ";\n  font-size: " + theme.typography.control.fontSize + ";\n  margin-left: " + theme.space.xxs + ";\n  color: " + theme.colors.gray700 + ";\n  && {\n    overflow: auto;\n  }\n";
});
var StyledIndicator = styled(Box)(function (_a) {
    var _b = _a.rotatesIcon, rotatesIcon = _b === void 0 ? false : _b, theme = _a.theme;
    return "\n  transform: " + (rotatesIcon ? 'rotate(180deg)' : 'rotate(0)') + ";\n  transition: " + theme.transitions.duration.fast + ";\n";
});
export function Control(props) {
    return (React.createElement(ControlWrapper, __assign({ ref: props.innerRef, disabled: props.isDisabled, error: props.selectProps.error, isTouched: props.selectProps.isTouched, isInvalid: props.selectProps.isInvalid, isFocused: props.isFocused, isFormik: props.selectProps.isFormik, lss: __assign({ display: 'flex', position: 'relative', alignItems: 'center', justifyContent: 'space-between', minHeight: '40px', minWidth: '200px' }, props.lss) }, props.innerProps), props.children));
}
function Placeholder(props) {
    return (React.createElement(StyledPlaceholder, __assign({ as: "span" }, props.innerProps), props.children));
}
function MultiValue(props) {
    var theme = useTheme();
    var _a = props.removeProps, onClick = _a.onClick, propsTag = __rest(_a, ["onClick"]);
    return (React.createElement(Tag, __assign({ tabIndex: -1, 
        // no-op when clicking on tag content
        onClick: noop, onRemove: function () {
            onClick(undefined);
        } }, propsTag, { lss: {
            my: 'xs',
            py: 0,
            px: 'md',
            mr: 'xs',
            ml: 0,
            textScale: 'control',
            borderRadius: 'md',
            bg: 'gray300',
            color: 'primary',
            ':hover': {
                background: theme['colors'].secondary200
            }
        } }), props.children));
}
export function Option(props) {
    // allow the customization of the Create Option
    return (React.createElement(OptionContainer, __assign({}, props.innerProps, { ref: props.innerRef, isFocused: props.isFocused, isSelected: props.isSelected, disabled: props.isDisabled, label: props.label, type: props.type, data: props.data, role: "option" }), props.children));
}
function DropdownIndicator(props) {
    var _a = props.selectProps, isLoading = _a.isLoading, menuIsOpen = _a.menuIsOpen;
    var icon = isLoading ? (React.createElement(Spinner, { size: "sm" })) : (React.createElement(MdArrowDropDown, { size: 20 }));
    return (React.createElement(StyledIndicator, __assign({ as: "span", rotatesIcon: !isLoading && menuIsOpen }, props.innerProps, { lss: {
            mr: 'sm'
        } }), icon));
}
function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (React.createElement(Box, __assign({}, innerProps, { lss: { mr: 'sm', color: 'gray700' } }), children || React.createElement(MdClose, { size: 14 })));
}
var LoadingIndicator = function () { return null; };
var IndicatorSeparator = function () { return null; };
var SingleValue = styled(components.SingleValue)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    overflow: initial;\n  }\n"], ["\n  && {\n    overflow: initial;\n  }\n"])));
var StyledMenu = styled(Box)(function (_a) {
    var theme = _a.theme;
    return "\n    position: relative;\n    z-index: " + theme.zIndices.selectMenu + ";\n";
});
function Menu(menuProps) {
    return (React.createElement(StyledMenu, null,
        React.createElement(components.Menu, __assign({}, menuProps))));
}
var MultiValueContainer = styled(components.MultiValueContainer)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-top: 0;\n  padding-bottom: 0;\n"], ["\n  padding-top: 0;\n  padding-bottom: 0;\n"])));
export function CreatableOption(props) {
    var children = props.data.__isNew__ ? (React.createElement(React.Fragment, null,
        props.selectProps.inputValue,
        ' ',
        React.createElement(Tag, { palette: "secondary", hasOutline: true, lss: {
                ml: 'sm'
            } }, "New"))) : (props.children);
    return React.createElement(Option, __assign({}, props), children);
}
export var BaseSelectComponents = {
    Control: Control,
    MultiValueContainer: MultiValueContainer,
    Menu: Menu,
    SingleValue: SingleValue,
    Placeholder: Placeholder,
    MultiValue: MultiValue,
    Option: Option,
    DropdownIndicator: DropdownIndicator,
    ClearIndicator: ClearIndicator,
    LoadingIndicator: LoadingIndicator,
    IndicatorSeparator: IndicatorSeparator
};
export default BaseSelectComponents;
var templateObject_1, templateObject_2;
//# sourceMappingURL=BaseSelectComponents.js.map